import { computed, onMounted, onUnmounted, shallowRef } from 'vue'
import type { CSSProperties } from 'vue'
import { APP_PAGE_LAYOUT } from '@/constants/app'

export function useAppPageScale() {
  const scale = shallowRef(1)

  function updateScale() {
    if (typeof window === 'undefined') {
      return
    }

    scale.value = Math.min(
      window.innerWidth / APP_PAGE_LAYOUT.baseWidth,
      window.innerHeight / APP_PAGE_LAYOUT.baseHeight,
    )
  }

  const stageStyle = computed<CSSProperties>(() => ({
    transform: `translate(-50%, -50%) scale(${scale.value})`,
  }))

  onMounted(() => {
    updateScale()
    window.addEventListener('resize', updateScale)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateScale)
  })

  return {
    scale,
    stageStyle,
  }
}
